module.exports = __webpack_public_path__ + "img/game_main_pc_speed_off.305d4426.png";